export default {
  Uuid: '',
  FantasyName: '',
  Active: false,
  Booking: false,
  Integrator: false,
  HeadOffice: false,
  Online: false,
};
